import { createOfferResource } from './offerResourceFactory'

/**
 * Цінові пропозиції тендерів (`SPEC-024` §3.3, §8) — блок «Цінові пропозиції»
 * картки власника. Ключ прав беку — `TenderOffer` (`ResourceCorrespondenceConfig`).
 */
export const TenderOfferResource = createOfferResource('tender')
